import { TreatmentCoordinatorView } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useTcHold } from '../hooks/useTcHold';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/**
 * AI Team › Treatment Coordinator (amendment 27 §9) — the read-only work stream.
 * People call from the Call list; ELVA makes no calls for TC.
 */
export function TreatmentCoordinatorPage() {
  const navigate = useNavigate();
  const { onHold, setHold } = useTcHold();
  const [period, setPeriod] = usePeriodRange();
  return (
    <TreatmentCoordinatorView
      onHold={onHold}
      onSetHold={setHold}
      period={period}
      onPeriodChange={setPeriod}
      onOpenCallList={() => { void navigate('/calls?type=treatment'); }}
      onOpenCampaigns={() => { void navigate('/treatment-intelligence/campaigns'); }}
      onOpenSettings={() => { void navigate('/settings/ai/treatment-coordinator'); }}
      onOpenTriage={() => { void navigate('/triage?source=treatment-coordinator'); }}
      onOpenCalls={() => { void navigate('/calls?type=treatment'); }}
      onOpenPatient={(id) => { void navigate(`/patients/${id}/treatments`); }}
      onViewAll={() => { void navigate('/communications?agent=treatment-coordinator'); }}
    />
  );
}
